/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access() {
  // const { currentUser } = initialState ?? {};
  return {
    // canAdmin: currentUser && currentUser.access === 'admin',
  };
}
